// src/utils/defaultPreflightHandler.ts
async function defaultPreflightHandler(args) {
  if (typeof args.options.body === "object") {
    args.options.body = JSON.stringify(args.options.body);
    args.options.headers ??= {
      "Content-Type": "application/json"
    };
  }
}
export {
  defaultPreflightHandler as default
};
